import { types } from '../../types/types';

export const zeraerrornetwork = () => {
    return dispatch => {
      dispatch({
        type: types.ERROR_NETWORK,
        payload: {}        
      })
    }
}
